// 引入axios
import axios from 'axios'
// 引入element-ui提示框组件
import {Message} from 'element-ui';
import router from '@/router/index';
import qs from 'qs'
import store from '@/store'

// 使用自定义配置新建一个axios实例
const service = axios.create({
  // 基础的请求地址
  baseURL: process.env.API_ROOT,
  // 设置超时时间30s
  timeout: 30000,
  //携带cookie
  withCredentials: true
})
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // if (store.getters.userInfo?.token) {
    //   config.headers.token = store.getters.userInfo.token
    // }
    /*if (config.method === 'POST') {
      console.log(config.data,'data')
      config.data = qs.stringify(config.data)
    }*/
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const { code, desc, data } = response.data
    //下载白名单 放行
    if(response.config.url == '/admin/resume/export' ||
      response.config.url == '/admin/order/exportBaiduAiOrderList' ||
      response.config.url == '/admin/order/exportBaiduOrderList' ||
      response.config.url.includes('/admin/youtube/monthly/analysis/exportByYmiIds') ||
      response.config.url.includes('/admin/youtube/monthly/analysis/exportByQuery')
    ){
      return response
    }
    // 要根据code的成功与否决定下面的操作
    if (code === 200) {
      return data
    } else {
      // 业务错误
      if (code === 401) {
        // 未登录或token失效,移除token
        store.commit('user/removeUserInfo');
        Message({
          type: 'error',
          message: desc || '请登录后再试'
        })
        router.push('/login');
      } else {
        Message({
          type: 'error',
          message: desc || '接口请求错误，请稍后重试'
        })
      }
      return Promise.reject(new Error(desc)) // 提示错误消息
    }
  },
  (error) => {
    // TODO：将来处理token超时问题
    Message.error(error.message) // 提示错误信息
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js